import { Button } from "@mui/material";
import React from "react";

const StockyButton = (props) => {
  return <Button {...props} />;
};

export default StockyButton;
